import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";
import "../../../styles/home1.css";

const qualityPurchaseData = [
 { name:"Jan", value:40 },
 { name:"Feb", value:60 },
 { name:"Mar", value:45 },
 { name:"Apr", value:70 },
 { name:"May", value:55 },
 { name:"Jun", value:80 },
 { name:"Jul", value:65 },
 { name:"Aug", value:90 }
];

export default function QualityPurchaseChart(){

return(

<div className="card shadow-sm border-0 h-100">
<div className="card-body">

<h6 className="fw-bold mb-3">Quality Purchase</h6>

<div style={{width:"100%",height:200}}>
<ResponsiveContainer>

<BarChart data={qualityPurchaseData}>
<Bar dataKey="value" fill="#9c27b0" radius={[4,4,0,0]} barSize={12}/>
<XAxis dataKey="name"/>
<YAxis/>
</BarChart>

</ResponsiveContainer>
</div>

</div>
</div>

);
}